import CaseStudyPage from "@/pages/portfolio/components/CaseStudyPage";

export default function FintechCase() {
  return <CaseStudyPage slug="fintech-dashboard" />;
}